import { render, staticRenderFns } from "./QuoteLayout.vue?vue&type=template&id=23946510"
import script from "./QuoteLayout.vue?vue&type=script&lang=js"
export * from "./QuoteLayout.vue?vue&type=script&lang=js"
import style0 from "./QuoteLayout.vue?vue&type=style&index=0&id=23946510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports